var map = {
	"./title-cn.png": "DIKA",
	"./title-de.png": "p+iO",
	"./title-en.png": "k84L",
	"./title-es.png": "S5M5",
	"./title-fr.png": "dRFE",
	"./title-pt.png": "dwxN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xSGy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title ^\.\/title\-.*\.png$
// module id = xSGy
// module chunks = 1